import { createRoute } from "@tanstack/react-router";
import { requirePermissions } from "@/app/guards";
import { USERS_PERMISSIONS } from "@/app/nav";
import { UserDetailPage } from "@/features/users/UserDetailPage";
import { UserList } from "@/features/users/UserList";
import { type PageSearch, pageSearch } from "@/routes/paging";
import { staffRoute } from "@/routes/staff";

/** q searches name and email; role is a role id. */
export type UsersSearch = { q?: string; role?: string; active?: boolean } & PageSearch;

const nonEmpty = (value: unknown) => (typeof value === "string" && value.trim() !== "" ? value.trim() : undefined);
// The router parses "true"/"false" in the query string into booleans.
const flag = (value: unknown) => (value === true || value === "true" ? true : value === false || value === "false" ? false : undefined);

export const usersRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "users",
  // Set, never omit, each key: the router merges this over the raw query string.
  validateSearch: (search: Record<string, unknown>): UsersSearch => ({
    q: nonEmpty(search.q),
    role: nonEmpty(search.role),
    active: flag(search.active),
    ...pageSearch(search),
  }),
  beforeLoad: ({ context }) => requirePermissions(context.session, USERS_PERMISSIONS),
  component: UserList,
});

export const userDetailRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "users/$userId",
  beforeLoad: ({ context }) => requirePermissions(context.session, USERS_PERMISSIONS),
  component: UserDetailPage,
});
